// store/slices/currencySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchUSDPrice = createAsyncThunk("currency/fetchUSDPrice", async () => {
  const res = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
  const data = await res.json();
  return data?.rates?.INR; // just return INR rate
});

const currencySlice = createSlice({
  name: "currency",
  initialState: {
    inrPrice: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUSDPrice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUSDPrice.fulfilled, (state, action) => {
        state.loading = false;
        state.inrPrice = action.payload;
      })
      .addCase(fetchUSDPrice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default currencySlice.reducer;
